import { Link, useSearchParams } from "react-router";
import { nombres, useInstituciones } from "@/features/instituciones";
import {
  contarPorEstado,
  esFiltro,
  ESTADOS,
  filtrar,
  RUTA_INVITAR,
  TablaUsuarios,
  useUsuarios,
  type FiltroEstado,
} from "@/features/usuarios";
import { t } from "@/shared/i18n";
import { Boton, CampoBusqueda, EncabezadoPagina, GrupoFiltros, Herramientas, Tarjeta, Vacio } from "@/shared/ui";
import { SegunConsulta, useTitulo } from "./comun";
import estilos from "./Paginas.module.css";

const u = t.usuarios;

export function Usuarios() {
  const consulta = useUsuarios();
  const instituciones = useInstituciones();
  const [parametros, setParametros] = useSearchParams();
  const buscar = parametros.get("q") ?? "";
  const crudo = parametros.get("estado");
  const filtro: FiltroEstado = esFiltro(crudo) ? crudo : "todos";
  useTitulo(u.titulo);

  function cambiar(q: string, f: FiltroEstado) {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (f !== "todos") p.set("estado", f);
    setParametros(p, { replace: true, preventScrollReset: true });
  }

  const lista = consulta.data ?? [];
  const cuentas = contarPorEstado(lista);
  const filas = filtrar(lista, buscar, filtro);

  return (
    <div className={estilos.pila}>
      <EncabezadoPagina
        titulo={u.titulo}
        subtitulo={u.subtitulo}
        lateral={
          <Link to={RUTA_INVITAR} className={estilos.enlaceBoton}>
            {u.invitar}
          </Link>
        }
      />
      <SegunConsulta consulta={consulta}>
        {() =>
          lista.length === 0 ? (
            <Tarjeta>
              <Vacio titulo={u.vacioTitulo}>{u.vacioTexto}</Vacio>
            </Tarjeta>
          ) : (
            <div>
              <Herramientas>
                <div className={estilos.buscador}>
                  <CampoBusqueda
                    rotulo={u.buscar}
                    placeholder={u.buscarAyuda}
                    valor={buscar}
                    alCambiar={(q) => {
                      cambiar(q, filtro);
                    }}
                  />
                </div>
                <GrupoFiltros
                  etiqueta={u.filtro}
                  activo={filtro}
                  alElegir={(f) => {
                    cambiar(buscar, f);
                  }}
                  opciones={[
                    { clave: "todos" as const, texto: u.todos, cuenta: cuentas.todos },
                    ...ESTADOS.map((e) => ({ clave: e, texto: t.estados[e], cuenta: cuentas[e] })),
                  ].filter((o) => o.clave === "todos" || o.cuenta > 0 || o.clave === filtro)}
                />
              </Herramientas>
              <div aria-live="polite">
                <Tarjeta>
                  {filas.length ? (
                    <TablaUsuarios usuarios={filas} nombres={nombres(instituciones.data ?? [])} />
                  ) : (
                    <Vacio titulo={u.sinResultadosTitulo}>
                      {u.sinResultadosTexto}{" "}
                      <Boton
                        variante="enlace"
                        onClick={() => {
                          cambiar("", "todos");
                        }}
                      >
                        {u.quitarFiltros}
                      </Boton>
                    </Vacio>
                  )}
                </Tarjeta>
              </div>
            </div>
          )
        }
      </SegunConsulta>
    </div>
  );
}
